export const DISCOUNT_TYPES = {
  PERCENTAGE: "porcentaje",
  FIXED_AMOUNT: "monto fijo",
  FREE_SHIPPING: "envio gratis",
} as const;

export const isFreeShippingCoupon = (coupon: Coupon): boolean =>
  coupon.type === DISCOUNT_TYPES.FREE_SHIPPING;
